import React from 'react';
import { Col } from 'antd';
import { EvaluationNameFormItem } from '@/components/views/Resolution886/components/Form';

export function EvaluationName(): JSX.Element {
	return (
		<Col xs={24}>
			<EvaluationNameFormItem fieldName="evaluation_name" required={false} />
		</Col>
	);
}
